import fetchServer from "../helpers/api/fetchServer";

export const createPlacement = async ({
  name,
  nameFrench,
  adPlatformCode,
  platformId,
  acceptedRatios
}) => {
  const method = "POST";
  const urlAPI = "/api/placements";
  const body = {
    name,
    nameFrench,
    adPlatformCode,
    platform: platformId,
    acceptedRatios
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getPlacements = async () => {
  const method = "GET";
  const urlAPI = "/api/placements";
  return await fetchServer({ method, urlAPI });
};

export const getPlacementsByPlatform = async (platformId) => {
  const method = "GET";
  const urlAPI = `/api/placements?platform=${platformId}`;
  return await fetchServer({ method, urlAPI });
};

export const getPlacement = async (id) => {
  const method = "GET";
  const urlAPI = `/api/placements/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updatePlacement = async ({
  id,
  name,
  nameFrench,
  adPlatformCode,
  platformId,
  acceptedRatios
}) => {
  const method = "PATCH";
  const urlAPI = `/api/placements/${id}`;
  const body = {
    name,
    nameFrench,
    adPlatformCode,
    platform: platformId,
    acceptedRatios
  };
  return await fetchServer({ method, urlAPI, body });
};

export const deletePlacement = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/placements/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restorePlacement = async (id) => {
  const method = "POST";
  const urlAPI = `/api/placements/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deletePlacements = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/placements/bulk-delete";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};

export const restorePlacements = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/placements/bulk-restore";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};
